import Box from '@mui/material/Box';
import React from 'react';
import styles from './styles';
import * as Sentry from '@sentry/browser';

export default (ComposedComponent) => {
  // eslint-disable-next-line no-unused-vars
  return class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }

    componentDidCatch(error) {
      Sentry.captureException(error);
      console.log(error);
    }

    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <Box style={styles.container}>
            <Box h3 style={{ textAlign: 'center' }}>
              Whoops!
            </Box>
            <Box h4 style={{ textAlign: 'center' }}>
              Something went wrong. This error has been reported.
            </Box>
          </Box>
        );
      }

      return <ComposedComponent {...this.props} />;
    }
  };
};
